import { FormAdapter } from 'core/utils/adapters'

export const SetupLicenseFormFields = {
  body: 'body'
}

export const SetupLicenseFormAdapter = new FormAdapter(SetupLicenseFormFields, 'setupLicenseForm')

